import React from 'react';
import {
  case_completed,
  case_pending,
  empty_wallet,
  mascot_img_main
} from '../../imagepath';
import { useNavigate } from 'react-router-dom';
import CountUp from 'react-countup';
import BreadCrumbs from '../../core/BreadCrumbs';
import { useUserProfile } from '../../../hooks/useUserProfile';
import { Button } from 'antd'; //Select, Typography
import { useDashboard } from '../../../hooks/dashboard/useDasboard';
const BREAD_CRUMBS = [{ label: 'Dashboard', to: '/user/admin-dashboard' }];

const Admin_Dashboard = () => {
  const { userProfile } = useUserProfile();
  const navigate = useNavigate();
  

  const { data } = useDashboard();

  return (
    <div>
      <div>
        {/* /Page Header */}
        <BreadCrumbs items={BREAD_CRUMBS} />
        <div className="good-morning-blk">
          <div className="row">
            <div className="col-md-6 col-lg-8 col-xl-8">
              <div className="morning-user">
                <h2>
                  Good Morning, <span>{userProfile?.fullName}</span>
                </h2>
                <p>Have a nice day at work</p>
                <p>
                  <small>(Below data is for the current month only!)</small>
                </p>
              </div>
            </div>
            <div className="col-md-6 col-lg-4 col-xl-4 position-blk">
              <div className="morning-img">
                <img src={mascot_img_main} alt="#" height={150} width={150} />
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 col-sm-6 col-lg-6 col-xl-3">
            <div className="dash-widget">
              <div className="dash-boxs comman-flex-center">
                <img src={case_pending} alt="#" />
              </div>
              <div className="dash-content dash-count">
                <h4>Assigned Cases</h4>
                <h2>
                  <CountUp
                    delay={0.4}
                    end={data?.assignedCases}
                    duration={0.6}
                  />
                </h2>
                <Button
                  size="small"
                  type="link"
                  className="p-0"
                  onClick={() => navigate('/user/case/new')}
                >
                  View All
                </Button>
              </div>
            </div>
          </div>
          <div className="col-md-6 col-sm-6 col-lg-6 col-xl-3">
            <div className="dash-widget">
              <div className="dash-boxs comman-flex-center">
                <img src={case_completed} alt="#" />
              </div>
              <div className="dash-content dash-count flex-grow-1">
                <h4>Completed Cases</h4>
                <h2>
                  {' '}
                  <CountUp
                    delay={0.4}
                    end={data?.completedCases}
                    duration={0.6}
                  />
                </h2>
                <Button
                  size="small"
                  type="link"
                  className="p-0"
                  onClick={() => navigate('/user/case/completed')}
                >
                  View All
                </Button>
              </div>
            </div>
          </div>
          <div className="col-md-6 col-sm-6 col-lg-6 col-xl-3">
            <div className="dash-widget">
              <div className="dash-boxs comman-flex-center">
                <img src={case_completed} alt="#" />
              </div>
              <div className="dash-content dash-count flex-grow-1">
                <h4>Rush Cases</h4>
                <h2>
                  {' '}
                  <CountUp
                    delay={0.4}
                    end={data?.rushCases}
                    duration={0.6}
                  />
                </h2>
                <Button
                  size="small"
                  type="link"
                  className="p-0"
                  onClick={() => navigate('/user/case/new?rushOnly=true')}
                >
                  View All
                </Button>
              </div>
            </div>
          </div>
          <div className="col-md-6 col-sm-6 col-lg-6 col-xl-3">
            <div className="dash-widget">
              <div className="dash-boxs comman-flex-center">
                <img src={empty_wallet} alt="#" />
              </div>
              <div className="dash-content dash-count">
                <h4>Revenue</h4>
                <h2>
                  $<CountUp delay={0.4} end={data?.invoicesAmountValue} duration={0.6} />
                </h2>
                <Button
                  size="small"
                  type="link"
                  className="p-0"
                  onClick={() => navigate('/user/radiologist-invoice-list')}
                >
                  View All
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Admin_Dashboard;
